import { Carousel as AntdCarousel } from "antd"

const Carousel = props => {
  return <AntdCarousel {...props} />
}

export default Carousel
